import * as React from "react"
import { Box } from "theme-ui"

export default function Text(props) {
  return <Box color="text.primary" {...props} />
}
